import { capitalize, pxToRem } from './utils'
/**
 * @enum {number}
 */
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
}
const breakpointsEntries = Object.entries(breakpoints)
/**
 * @typedef {{[k in keyof typeof breakpoints as `${k}Only`]: {min?: string, max?: string}}} OnlyValues
 * @typedef {{[k in keyof typeof breakpoints as `before${Capitalize<k>}`]: {min?: string, max?: string}}} BeforeValues
 * @typedef {{[k in keyof typeof breakpoints]: string}} Values
 *
 * @typedef {OnlyValues & BeforeValues & Values} Breakpoints
 *
 * @type {Breakpoints}
 */
// @ts-ignore
export const screens = breakpointsEntries.reduce((acc, [name, value], i) => {
  const nextBreakpoint = breakpointsEntries[i + 1]
  acc[name] = pxToRem(value)
  acc[`${name}Only`] = nextBreakpoint
    ? { min: pxToRem(value), max: pxToRem(nextBreakpoint[1] - 1) }
    : { min: pxToRem(value) }

  acc[`before${capitalize(name)}`] = { max: pxToRem(value - 1) }
  return acc
}, {})

export const flexGrid = {
  columns: 12,
  gutter: 32,
  container: {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536
  }
}

export default {
  flexGrid,
  screens
}
